import { AbstractEntity } from "./abstract-entity.model";
import { MinDTO } from "./min-dto";

export class SearchLogCommentModel extends AbstractEntity {
    comment: string;
    score: number;
    marketSearchLogClickHistory: MinDTO
    created: boolean = false;
}